/* eslint-disable camelcase */
import { Snackbar, SnackbarContent, Typography } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import Slide from '@material-ui/core/Slide'
import withStyles from '@material-ui/core/styles/withStyles'
import CloseIcon from '@material-ui/icons/Close'
import classNames from 'classnames'
import * as PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Icon from '@mdi/react'
import {
  mdiAlertCircleOutline,
  mdiCheckCircleOutline,
  mdiInformationOutline,
} from '@mdi/js'

import { clearSnackbar } from '../main/MainActions'
import { getSnackbar } from '../main/MainReducer'
import colors from '../../assets/colors'

const AUTOCLOSE_DURATION = 1000 * 6

const SEVERITIES = {
  error: {
    icon: mdiAlertCircleOutline,
    color: colors.error,
    title: 'Erro!',
  },
  success: {
    icon: mdiCheckCircleOutline,
    color: colors.sucess,
    title: 'Sucesso!',
  },
  info: {
    icon: mdiInformationOutline,
    color: colors.info,
    title: null,
  },
}

const styles = () => ({
  error: {
    backgroundColor: colors.bgError,
    borderLeft: `4px solid ${colors.error}`,
  },
  success: {
    backgroundColor: colors.bgSucess,
    borderLeft: `4px solid ${colors.sucess}`,
  },
  info: {
    backgroundColor: colors.bgInfo,
    borderLeft: `4px solid ${colors.info}`,
  },
  snackBar: {
    boxShadow: '0 4px 12px rgba(0, 11, 65, 0.15)',
    borderRadius: '4px',
    padding: '4px 8px',
    color: colors.primary,
    flexWrap: 'nowrap',
    maxWidth: '420px',
  },
  message: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    padding: '8px 0',
    minWidth: 0,
  },
  icon: {
    flexShrink: 0,
    lineHeight: 0,
    marginTop: '2px',
  },
  text: {
    fontSize: '0.875rem',
    lineHeight: 1.4,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
  title: {
    fontWeight: 700,
    fontSize: 'inherit',
    marginRight: '4px',
    display: 'inline',
  },
  action: {
    paddingLeft: '8px',
    marginRight: 0,
    alignSelf: 'flex-start',
  },
  closeButton: {
    padding: '4px',
  },
})

function Transition(props) {
  return <Slide {...props} direction="left" />
}

class Snackbars extends Component {
  constructor(props) {
    super(props)
    this.state = {
      message: null,
      open: false,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.snackbar) {
      this.setState({
        open: true,
        message: nextProps.snackbar.message,
        success: nextProps.snackbar.success,
        info: nextProps.snackbar.info,
      })
    }
  }

  handleClose = (event, reason) => {
    const { doClear } = this.props

    if (reason === 'clickaway') {
      return
    }

    this.setState({
      open: false,
    })
    doClear()
  }

  renderMessage = (message, type) => {
    const { classes } = this.props
    const { icon, color, title } = SEVERITIES[type]

    return (
      <div className={classes.message}>
        <span className={classes.icon}>
          <Icon path={icon} color={color} size={0.95} />
        </span>
        <Typography component="div" className={classes.text}>
          {title && (
            <Typography component="span" className={classes.title}>
              {title}
            </Typography>
          )}
          {message}
        </Typography>
      </div>
    )
  }

  render() {
    const { classes } = this.props
    const { message, success, info, open } = this.state

    if (!message) {
      return null
    }

    const severity = () => {
      if (info) {
        return 'info'
      }

      if (success) {
        return 'success'
      }

      return 'error'
    }

    return (
      <Snackbar
        key={message}
        disableWindowBlurListener
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        autoHideDuration={AUTOCLOSE_DURATION}
        onClose={this.handleClose}
        TransitionComponent={Transition}
      >
        <SnackbarContent
          classes={{ action: classes.action }}
          className={classNames(classes[severity()], classes.snackBar)}
          message={this.renderMessage(message, severity())}
          action={
            <IconButton
              key="close"
              aria-label="Fechar"
              color="inherit"
              className={classes.closeButton}
              onClick={this.handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        />
      </Snackbar>
    )
  }
}

Snackbars.propTypes = {
  doClear: PropTypes.func.isRequired,
  snackbar: PropTypes.object,
  classes: PropTypes.object,
}

const mapStateToProps = store => ({
  snackbar: getSnackbar(store),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      doClear: clearSnackbar,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Snackbars))
